import type {Context} from '../types';

import _ from 'lodash';
import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';
import {generateGuid} from '@packages/utilities/guid';

type SliderArrowJSONNode = {
  _id: string;
  children: Array<string>;
  data: {
    slider: {
      type: 'arrow';
      dir: 'left' | 'right';
    };
  };
};

// Fix legacy slider arrow nodes without icons
export default (context: Context) => {
  const {
    node: {jsonNode},
    tree: {nodeMap},
    fn: {insertNodesAfter},
  } = context;
  const {data = {}} = jsonNode;

  const _migrateSliderArrow = (arrowNode: SliderArrowJSONNode) => {
    // Exit early if arrow has child nodes
    if (arrowNode.children.length) {
      return null;
    }

    // Create icon node json
    const direction = arrowNode.data.slider.dir;
    const iconNode = {
      _id: generateGuid(),
      tag: 'div',
      classes: [],
      children: [],
      data: {
        widget: {
          type: 'icon',
          icon: `slider-${direction}`,
        },
      },
    };

    // Add icon to arrow children and return created node
    arrowNode.children.push(iconNode._id);
    return iconNode;
  };

  return {
    needed: DomTypeUtils.isSliderWrapper(data) && !data.slider.iconArrows,
    logData: {
      msg: 'Slider without iconArrows',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      data.slider.iconArrows = true;
      _.each(jsonNode.children, (childId) => {
        const childNode = nodeMap.get(childId);
        if (childNode && DomTypeUtils.isSliderArrow(childNode.data)) {
          const iconNode = _migrateSliderArrow(
            // We know this is a SliderArrow because of the DomTypeUtils check.
            childNode as SliderArrowJSONNode
          );
          if (iconNode) {
            insertNodesAfter(childId, [iconNode]);
          }
        }
      });
    },
  };
};
